import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AjaxHelper } from '../helper/ajax.helper';
import { BaseResponse } from '../model/base.response';
import { WebConstants } from '../util/web.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GeofenceZoneService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper,
    private httpClient: HttpClient) {
  }

  getAll(): Observable<BaseResponse<any>> {
    return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE_ZONE.FIND_ALL_GEOFENCE_ZONE);
  }

  addGeofenceZone(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_ZONE.ADD_GEOFENCE_ZONE, payload);
  }

  updateGeofenceZone(payload: any): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_ZONE.UPDATE_GEOFENCE_ZONE, payload);
  }

  deleteGeofenceZone(id: Number): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_ZONE.DELETE_GEOFENCE_ZONE + id, id);
  }

  deleteGeofenceZoneByGeofenceId(id: Number): Observable<BaseResponse<any>> {
    return this.ajaxHelper.post(this.baseUrl + WebConstants.API_URL.GEOFENCE_ZONE.DELETE_GEOFENCE_ZONE_BY_GEOFENCE_ID + id, id);
  }

  // getGeofenceById(geofenceId: Number): Observable<BaseResponse<any>> {
  //   return this.ajaxHelper.get(this.baseUrl + WebConstants.API_URL.GEOFENCE.FIND_GEOFENCE_BY_ID + geofenceId);
  // }
}
